import { render, staticRenderFns } from "./autoCompleteUsers.vue?vue&type=template&id=00048501&scoped=true&"
import script from "./autoCompleteUsers.vue?vue&type=script&lang=js&"
export * from "./autoCompleteUsers.vue?vue&type=script&lang=js&"
import style0 from "./autoCompleteUsers.vue?vue&type=style&index=0&id=00048501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00048501",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VAvatar,VChip,VListItemContent,VListItemTitle})
